/**
 * API Route constants used across the application.
 * Add all backend endpoints here for consistent usage.
 */
export const API_ROUTES = {
    SIGNIN: '/v1/auth/signin',
    SIGNUP: '/v1/user',
    COUNTRIES: '/v1/common/countries',
    STATES: '/v1/common/states',
    GET_MENUS: '/v1/menus',
    LIST_CATEGORY: '/v1/category/',
    GET_ONE_CATEGORY: '/v1/category/{id}',
    ADD_CATEGORY: '/v1/category/',
    UPDATE_CATEGORY: '/v1/category/{id}'
}